<template>
	<div class="MapLegend">
		<div v-if="showRouteColor" class="MapLegend__item">
			<span class="MapLegend__marker" :style="{ backgroundColor: routeColor }"></span>
			<span>Kolor markera: trasa</span>
		</div>
		<div v-if="showUserBadge" class="MapLegend__item">
			<span class="MapLegend__badge">SK</span>
			<span>Badge: użytkownik</span>
		</div>
		<div v-if="showPermanentPoint" class="MapLegend__item">
			<span class="MapLegend__marker MapLegend__marker--permanent">★</span>
			<span>Żółte oznaczenie: punkt stały</span>
		</div>
		<div v-if="showSelected" class="MapLegend__item">
			<span class="MapLegend__marker MapLegend__marker--selected">✓</span>
			<span>Zaznaczenie: punkt wybrany</span>
		</div>
	</div>
</template>

<script>
export default {
	name: 'MapLegend',
	props: {
		mode: {
			type: String,
			default: 'details'
		},
		routeColor: {
			type: String,
			default: '#1974D2'
		},
		hasPermanentPoints: {
			type: Boolean,
			default: false
		},
		hasSelectedPoints: {
			type: Boolean,
			default: false
		}
	},
	computed: {
		showRouteColor() {
			return true
		},
		showUserBadge() {
			return this.mode !== 'planning'
		},
		showPermanentPoint() {
			return this.hasPermanentPoints
		},
		showSelected() {
			return this.mode === 'planning' || this.hasSelectedPoints
		}
	}
}
</script>

<style lang="scss" scoped>
.MapLegend {
	position: absolute;
	right: 12px;
	bottom: 18px;
	z-index: 500;
	display: grid;
	gap: 6px;
	max-width: 230px;
	padding: 8px 10px;
	background: rgba(255, 255, 255, 0.94);
	border: 1px solid rgba(0, 0, 0, 0.14);
	border-radius: 4px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.12);
	font-size: 12px;
	color: #1f2937;
}

.MapLegend__item {
	display: grid;
	grid-template-columns: 22px minmax(0, 1fr);
	align-items: center;
	gap: 7px;
}

.MapLegend__marker,
.MapLegend__badge {
	width: 20px;
	height: 20px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	border: 2px solid #fff;
	box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
	font-weight: 700;
	font-size: 10px;
	color: #fff;
	background: #1974D2;
}

.MapLegend__badge {
	color: #1f2937;
	background: #f8fafc;
}

.MapLegend__marker--permanent {
	background: #FADA5E;
	color: #4a3a00;
}

.MapLegend__marker--selected {
	background: #1db954;
}
</style>
